<template>
  <section>
    <div class="parallax-group scrollTrigger">
      <div class="column-1" v-bind:style="{ 'margin-top': column1Pos + '%' }">
        <div class="item-container" v-for="(item, index) in getColumn(1)" :key="index">
          <flip-card :image="item.image" :link="item.link" :header="item.header" :description="item.description" :text="item.text" />
        </div>
      </div>
      <div class="column-2" v-bind:style="{ 'margin-top': column2Pos + '%' }">
        <div class="item-container" v-for="(item, index) in getColumn(2)" :key="index">
          <flip-card :image="item.image" :link="item.link" :header="item.header" :description="item.description" :text="item.text" />
        </div>
      </div>
      <div class="column-3" v-bind:style="{ 'margin-top': column3Pos + '%' }">
        <div class="item-container" v-for="(item, index) in getColumn(3)" :key="index">
          <flip-card :image="item.image" :link="item.link" :header="item.header" :description="item.description" :text="item.text" />
        </div>
      </div>
    </div>
  </section>
</template>
 
<script>
import scrollMagic from 'scrollmagic'
import flipCard from '@/components/stories/FlipCard.vue'
   
  export default {
     name: 'parallax-component',
    components: {
      flipCard
    },
    data() {
      return {
        scrollVal: 0,
        scrollDirection: 'FORWARD',
        column1Pos: 30,
        column2Pos: 5,
        column3Pos: 30,
        minMargin: 5,
        maxMargin: 20,
        scrollTrigger: false,
        windowHeight: 0,
        active: false,
        content: this.getJourneyContent()
      }      
    },
    mounted() {
       var controller = new scrollMagic.Controller();
       // eslint-disable-next-line
      var scene = new scrollMagic.Scene({triggerElement: ".scrollTrigger", duration: 200})
        .addTo(controller).on("update",  (e) => {if(this.scrollTrigger){ this.updatePos(e);} })
        .on("progress",  (e) => { this.scrollTrigger = true; this.scrollDirection = e.scrollDirection;  }); 
    },
    methods: {
        updatePos(e) {
          this.scrollVal =  e.scrollPos / 5000;
          this.scrollReversedDirection();
          this.checkScrollThreshhold();
          this.column3Pos = this.column1Pos; 
        },
        scrollReversedDirection(){
            if(this.scrollDirection === 'FORWARD') this.column1Pos -= this.scrollVal;
            else if(this.scrollDirection === 'REVERSE') this.column1Pos += this.scrollVal;
        },
        checkScrollThreshhold(){
            if(this.column1Pos > this.maxMargin) this.column1Pos = this.maxMargin;
            if(this.column1Pos < this.minMargin) this.column1Pos = this.minMargin;
        },
        getColumn(val) {
            return this.content.filter(i => i.column === val);
        },
        getJourneyContent() {
            return this.$store.getters['CONTENTDATA/JOURNEYGRID']
        }
    },
  }
</script>

<style lang="postcss" scoped>
.parallax-group {
  position: relative;
  z-index: 900;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin: auto;
}
.parallax-group > div {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}


.item-container {
  width: 100%;
  height: 100%;
  text-align: center;
  flex-direction: column;
}



</style>